
import React from 'react';
import {useState} from 'react'
import { Typography,Box, Tab, Tabs } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ManagerNavBar from '../../Components/NavigationBar/ManagerNavBar';
import DeviceAttendanceAnalytics from '../../Components/Manager/Reports.js/DeviceAttendanceAnalytics';
import MachineOperationReport from './ReportComponents/MachineOperationReport';
import WorkerOperationReport from '../../Components/Manager/Attendance/Reports/WorkerOperationReport';


function ManagerReports() {
    
  const [activeTab, setActiveTab] = useState(0)

  return (
    <ManagerNavBar>
    <Box sx={{ px: 6, py: 2 }}>
        <Typography sx={{ fontSize: '30px', fontWeight: 700, color: 'primary.main', mb: 3 }}>
                    Raporty
                </Typography>
          <Tabs
              value={activeTab}
              onChange={(e, newValue) => setActiveTab(newValue)}
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{ mb: 2 }} >
            <Tab label="Raport pracy maszyn" />
            <Tab label="Raport pracy pracowników" />
          </Tabs>

          {activeTab === 0 && (
            <Box>
              <MachineOperationReport />
            </Box>
          )}

    {activeTab === 1 && (
            <WorkerOperationReport />
          )}
        </Box>
    </ManagerNavBar>
  );
}

export default ManagerReports;
